/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:767px){.swiper-container[_ngcontent-%COMP%]{width:630px}}@media (min-width:900px){.swiper-container[_ngcontent-%COMP%]{width:860px}}@media (min-width:1200px){.swiper-container[_ngcontent-%COMP%]{width:1000px}}.custom-columns[_ngcontent-%COMP%]{-moz-columns:3;columns:3;padding:0;margin:0}"];
export { styles as styles };
